import React, {Component} from "react";
import "../SliderQuotationContent.css";
import {Link} from 'react-router-dom';
import {FormattedMessage} from "react-intl";
import Image1 from '../../../../../../assets/img/1.jpg';
import Image2 from '../../../../../../assets/img/2.jpg';
import ManufactureDocument from "./ManufactureDocument";
import {PAGE_OPEN_TYPE} from "../../../../../../configuration";

class SliderQuotationContent3 extends Component {
    render() {
        return (
            <div className="row">
                <div className="text-center">
                    <h3><b>
                        <FormattedMessage id="app.image-slider.quotation.centent3-heading"
                                          defaultMessage="Production Specification"
                                          description=""/>
                    </b>
                    </h3>
                </div>
                <div className="text-center description-div">
                    <p className="quotation-content-caption caption-content-3">
                        {/*<FormattedMessage id="app.image-slider.quotation.centent3-description"*/}
                        {/*defaultMessage="It is a list of specifications that can be supported when ordering various services."*/}
                        {/*description=""/>*/}
                        <p className="font-size-13"><b>製造対応可能なプリント基板製造基準です</b></p>
                        <p className="font-size-13"><b>サービスご利用前にご参照ください。</b></p>
                    </p>
                </div>
                <div className="col-md-12 text-center">
                    <b> 基板製造基準</b>
                    <br/>
                    <br/>
                    <table className="content3-table">
                        <tbody>
                        {/*<tr >*/}
                            {/*/!*<td>*!/*/}
                                {/*/!*<FormattedMessage id="app.image-slider.quotation.centent3-image1"*!/*/}
                                                  {/*/!*defaultMessage="Substrate Manufacturing"*!/*/}
                                                  {/*/!*description=""/>*!/*/}
                            {/*/!*</td>*!/*/}
                            {/*<td>*/}
                                {/*<FormattedMessage id="app.image-slider.quotation.centent3-image2"*/}
                                                  {/*defaultMessage="Metal Mask Manufacturing"*/}
                                                  {/*description=""/>*/}
                            {/*</td>*/}
                        {/*</tr>*/}
                        <tr>
                            {/*<td>*/}
                                {/*<Link to={{*/}
                                    {/*pathname: '/manufacture',*/}
                                {/*}}>*/}
                                    {/*<img src={Image1} alt="Image" className="image-width"/>*/}
                                {/*</Link>*/}
                            {/*</td>*/}
                            <td>
                                <a href="https://kitcutlabo.blog/kitcut-pcb-standards"
                                target={PAGE_OPEN_TYPE}>

                                    <img src={Image2} alt="Image" className="image-width"/>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        );
    }

}

export default SliderQuotationContent3;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/ImageSlider/ImageSliderQuotation/SliderQuotationContent3/SliderQuotationContent3.js